module.exports = __webpack_public_path__ + "static/media/refurbishKitchen2.4576f5c0.jpg";